import React, { useState } from "react"
import { Card, CardBody, Col, Row } from "reactstrap"
import { connect } from "react-redux"
import {
  deleteInvite,
  deleteRsvp,
  downloadAttendeeList,
  editAttendee,
  editAttendeeAndRsvp,
  getEventInviteList,
  openInactiveEventWarningModal,
  sendAppInvites,
  sendEmailInvite,
  setEventInviteListSortOptions,
  updateRsvp,
} from "store/actions"
import { SaveButton } from "components/Buttons"
import Table from "components/Table"
import userManagementListColumns from "./userManagementListColumns"
import { getUpdatedCheckedItemsList } from "utils"
import { withRouter } from "react-router-dom"
import { ActionsDropdown } from "components/Dropdowns"
import ModalComponent from "components/Modals"
import EditInviteModal from "./editInviteModal"

const UserManagementTab = ({
  eventInviteList,
  deleteInvite,
  eventInviteListSortOptions,
  setEventInviteListSortOptions,
  vendorId,
  selectedEvent,
  getEventInviteList,
  editAttendee,
  updateRsvp,
  openInactiveEventWarningModal,
  editAttendeeAndRsvp,
  deleteRsvp,
  history,
  sendAppInvites,
  sendEmailInvite,
  downloadAttendeeList,
}) => {
  const [checkedItems, setCheckedItems] = useState([])
  const [selectedItem, setSelectedItem] = useState(null)
  const [showResetButton, setShowResetButton] = useState(false)
  const [searchValues, setSearchValues] = useState("")
  const [appInviteModalIsOpen, setAppInviteModalIsOpen] = useState(false)
  const [deleteModalIsOpen, setDeleteModalIsOpen] = useState(false)
  const [selectedAttendee, setSelectedAttendee] = useState(null)
  const [editModalIsOpen, setEditModalIsOpen] = useState(false)

  const handleDeleteInvite = () => {
    if (!selectedItem) {
      const rsvp_ids = eventInviteList.data
        .filter(item => checkedItems.includes(item.user_id) && !item.invite_id)
        .map(x => x.rsvp_id)
      const invite_ids = eventInviteList.data
        .filter(
          item => checkedItems.includes(item.user_id) && item.invite_id !== null
        )
        .map(x => x.invite_id)
      if (rsvp_ids.length > 0) {
        deleteRsvp({
          vendorId,
          eventId: selectedEvent.id,
          rsvp_ids: rsvp_ids,
          callback: () => {
            setDeleteModalIsOpen(false)
          },
        })
      }
      if (invite_ids.length > 0) {
        deleteInvite({
          invite_ids: invite_ids,
          callback: () => {
            setDeleteModalIsOpen(false)
          },
        })
      }
      setCheckedItems([])
    } else {
      if (!selectedItem.invite_id) {
        deleteRsvp({
          vendorId,
          eventId: selectedEvent.id,
          rsvp_ids: [selectedItem.rsvp_id],
          callback: () => {
            setDeleteModalIsOpen(false)
          },
        })
      } else {
        deleteInvite({
          invite_ids: [selectedItem.invite_id],
          callback: () => {
            setDeleteModalIsOpen(false)
          },
        })
      }
    }
  }

  const deleteActionHandler = item => {
    setSelectedItem(item)
    setDeleteModalIsOpen(true)
  }

  const deleteButtonHandler = () => {
    setSelectedItem(null)
    setDeleteModalIsOpen(true)
  }

  const editActionHandler = item => {
    setSelectedAttendee(item)
    setEditModalIsOpen(true)
  }

  const actions = [
    {
      name: "Edit",
      onClick: editActionHandler,
      icon: "bx bx-edit",
      isAvailable: true,
    },
    {
      name: "Delete",
      onClick: deleteActionHandler,
      icon: "bx bx-trash",
      isAvailable: true,
    },
  ]

  const handleCheckItem = (item, checked) => {
    let checkedItemsList = getUpdatedCheckedItemsList(
      item,
      checked,
      checkedItems
    )
    setCheckedItems(checkedItemsList)
  }

  const handleCheckAllItems = (items, checked) => {
    let list = []
    if (checked) {
      for (let i = 0; i < items.length; i++) {
        list.push(items[i].id)
      }
    }
    setCheckedItems(list)
  }

  function handleSort(type, { sortField, sortOrder }) {
    let sortOption = { ...eventInviteListSortOptions }
    switch (sortField) {
      case "first_name":
        sortOption = { ...sortOption, o: "name", od: sortOrder }
        break
      case "last_sent":
        sortOption = { ...sortOption, o: "date", od: sortOrder }
        break
      default:
        sortOption = { ...sortOption, o: sortField, od: sortOrder }
    }
    setEventInviteListSortOptions(sortOption)
    getEventInviteList(vendorId, selectedEvent.id, sortOption)
  }

  const editAttendeeSubmitHandler = (rsvpWasUpdated, inputValues) => {
    if (selectedAttendee.rsvp_string_type === "Meta Tag") {
      if (rsvpWasUpdated) {
        updateRsvp(
          selectedEvent.id,
          vendorId,
          {
            id: inputValues.rsvp_id,
            invite_id: null,
            status: inputValues.rsvp_status,
            total_participants: inputValues.total_participants,
          },
          eventInviteListSortOptions
        )
        return
      }
    }
    if (rsvpWasUpdated) {
      editAttendeeAndRsvp(
        selectedEvent.id,
        {
          id: inputValues.rsvp_id,
          invite_id: inputValues.invite_id,
          status: inputValues.rsvp_status,
          total_participants: inputValues.total_participants,
        },
        inputValues
      )
    } else {
      editAttendee(inputValues)
    }
  }

  const sendEmailInviteHandler = () => {
    if (selectedEvent.published === false) {
      openInactiveEventWarningModal()
    } else {
      sendEmailInvite({
        event_id: selectedEvent?.id,
        invite_ids: eventInviteList?.data
          ?.filter(invite => checkedItems?.includes(invite?.user_id))
          ?.map(i => i?.invite_id)
          ?.filter(i => !!i),
        vendor_id: vendorId,
      })
    }
  }

  const handleSearch = () => {
    if (searchValues) {
      getEventInviteList(vendorId, selectedEvent.id, {
        ...eventInviteListSortOptions,
        s: searchValues,
      })
      setShowResetButton(true)
      setEventInviteListSortOptions({
        ...eventInviteListSortOptions,
        s: searchValues,
      })
    }
  }

  const handleReset = () => {
    if (searchValues) {
      setSearchValues("")
    }
    setShowResetButton(false)
    getEventInviteList(vendorId, selectedEvent.id, {
      o: eventInviteListSortOptions.o,
      od: eventInviteListSortOptions.od,
    })
    setEventInviteListSortOptions({
      o: eventInviteListSortOptions.o,
      od: eventInviteListSortOptions.od,
    })
  }

  const loadMoreAttendeesHandler = () => {
    setEventInviteListSortOptions({
      o: eventInviteListSortOptions.o,
      od: eventInviteListSortOptions.od,
      perPage: eventInviteList?.to + 25,
    })
    getEventInviteList(vendorId, selectedEvent.id, {
      o: eventInviteListSortOptions.o,
      od: eventInviteListSortOptions.od,
      perPage: eventInviteList?.to + 25,
    })
  }

  const sendCustomEmailHandler = () => {
    localStorage.setItem("commUsers", JSON.stringify(checkedItems))
    history.push(`/add-custom-email`)
  }

  const sendCustomNotificationHandler = () => {
    localStorage.setItem("commUsers", JSON.stringify(checkedItems))
    history.push(`/add-notification`)
  }

  const bulkActions = [
    {
      name: "Send Email Invite",
      onClick: sendEmailInviteHandler,
      icon: "bx bx-notification",
      isAvailable: checkedItems.length > 0,
    },
    {
      name: "Send App Invite",
      onClick: () => setAppInviteModalIsOpen(true),
      icon: "bx bx-send",
      isAvailable: checkedItems.length > 0,
    },
    {
      name: "Send Custom Email",
      onClick: sendCustomEmailHandler,
      icon: "bx bx-mail-send",
      isAvailable: checkedItems.length > 0,
    },
    {
      name: "Send Custom Notification",
      onClick: sendCustomNotificationHandler,
      icon: "bx bxs-bell-ring",
      isAvailable: checkedItems.length > 0,
    },
    {
      name: "Delete Users",
      onClick: deleteButtonHandler,
      icon: "bx bx-trash",
      isAvailable: checkedItems.length > 0,
    },
  ]

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <Row className="d-flex justify-content-between">
            <Col xs="auto" className="mt-1">
              <h3>User Management</h3>
            </Col>
            <Col xs={12} md="auto">
              <Row className="form-group">
                <Col xs={12} sm={6} md="auto" className="mt-1">
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control"
                    value={searchValues}
                    onChange={event => {
                      setSearchValues(event.target.value)
                    }}
                  />
                </Col>
                <Col xs={12} sm="auto" className="my-1">
                  <SaveButton
                    type="button"
                    content={"Search"}
                    fullWidth={true}
                    onClick={handleSearch}
                  />
                </Col>
                {showResetButton && (
                  <Col xs={12} sm="auto" className="d-none d-md-block my-1">
                    <SaveButton
                      content={"Reset"}
                      color="light"
                      fullWidth={true}
                      type="button"
                      onClick={handleReset}
                    />
                  </Col>
                )}
              </Row>
            </Col>
            <Col xs="auto" xl={1}></Col>
          </Row>
          <Row className="justify-content-between mb-2 mt-3">
            <Col xs="auto">
              <ActionsDropdown
                fullWidth={true}
                label={"Bulk actions"}
                actionsList={bulkActions}
                menuPosition={"start"}
                color="success"
              />
            </Col>
            <Col xs={1} style={{ minWidth: "fit-content" }}>
              <SaveButton
                type="button"
                content="Download List"
                fullWidth={true}
                onClick={() => {
                  downloadAttendeeList({
                    vendor_id: vendorId,
                    event_id: selectedEvent?.id,
                    values: { page: 1, download: 1, o: "name", od: "asc" },
                  })
                }}
                disabled={
                  !(
                    eventInviteList.hasOwnProperty("data") &&
                    eventInviteList?.data.length > 0
                  )
                }
              />
            </Col>
          </Row>
          <Table
            columns={userManagementListColumns(selectedEvent)}
            data={eventInviteList?.data?.map(item => ({
              ...item,
              id: item.user_id,
            }))}
            withCheckboxes={true}
            onCheckItem={handleCheckItem}
            onCheckAllItems={handleCheckAllItems}
            actions={actions}
            onTableSort={handleSort}
            defaultSorted={[
              {
                dataField: eventInviteListSortOptions.o,
                order: eventInviteListSortOptions.od,
              },
            ]}
          />
          {eventInviteListSortOptions.perPage < eventInviteList.total && (
            <Row className="d-flex justify-content-center">
              <Col xl={2}>
                <SaveButton
                  type="button"
                  fullWidth={true}
                  content="Load More Attendees"
                  onClick={loadMoreAttendeesHandler}
                />
              </Col>
            </Row>
          )}
        </CardBody>
      </Card>
      <ModalComponent
        title="Send App Invite"
        open={appInviteModalIsOpen}
        onClose={() => setAppInviteModalIsOpen(false)}
      >
        <Row>
          <span>
            Would you like to send the app invite to {checkedItems.length}{" "}
            selected users?
          </span>
          <span>
            The app invite will only be sent to Pending users, if the users are
            already Active, they will not receive an app invite.
          </span>
        </Row>
        <Row className="mt-3">
          <Col>
            <SaveButton
              type="button"
              fullWidth={true}
              color="danger"
              content="Cancel"
              onClick={() => setAppInviteModalIsOpen(false)}
            />
          </Col>
          <Col>
            <SaveButton
              content="Send"
              fullWidth={true}
              onClick={() =>
                sendAppInvites({
                  values: {
                    users: checkedItems,
                    vendor_id: vendorId,
                  },
                  callback: () => setAppInviteModalIsOpen(false),
                })
              }
            />
          </Col>
        </Row>
      </ModalComponent>
      <ModalComponent
        title="Delete Attendee"
        open={deleteModalIsOpen}
        onClose={() => {
          setDeleteModalIsOpen(false)
        }}
      >
        <Row>
          <h5>Are you sure you want to delete the selected attendee(s)?</h5>
        </Row>
        <Row>
          <Col>
            <SaveButton
              type="button"
              fullWidth={true}
              color="danger"
              content="Cancel"
              onClick={() => {
                setDeleteModalIsOpen(false)
              }}
            />
          </Col>
          <Col>
            <SaveButton
              content="Delete"
              fullWidth={true}
              onClick={() => handleDeleteInvite()}
            />
          </Col>
        </Row>
      </ModalComponent>
      <ModalComponent
        title="Edit Attendee"
        open={editModalIsOpen}
        onClose={() => {
          setEditModalIsOpen(false)
          setSelectedAttendee(null)
        }}
      >
        <EditInviteModal
          selectedAttendee={selectedAttendee}
          editAttendeeSubmitHandler={editAttendeeSubmitHandler}
          onClose={() => {
            setEditModalIsOpen(false)
            setSelectedAttendee(null)
          }}
        />
      </ModalComponent>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  vendorId: state.Login.vendorId,
  selectedEvent: state.experiences.selectedEvent,
  eventInviteList: state.experiences.eventInviteList,
  eventInviteListSortOptions: state.experiences.eventInviteListSortOptions,
})

const mapDispatchToProps = dispacth => ({
  getEventInviteList: (vendorId, eventId, sortOptions) =>
    dispacth(getEventInviteList(vendorId, eventId, sortOptions)),
  deleteInvite: values => dispacth(deleteInvite(values)),
  setEventInviteListSortOptions: sortOptions =>
    dispacth(setEventInviteListSortOptions(sortOptions)),
  editAttendee: values => dispacth(editAttendee(values)),
  updateRsvp: (eventId, vendorId, rsvp, eventInviteListSortOptions) =>
    dispacth(updateRsvp(eventId, vendorId, rsvp, eventInviteListSortOptions)),
  openInactiveEventWarningModal: () =>
    dispacth(openInactiveEventWarningModal()),
  editAttendeeAndRsvp: (eventId, rsvp, attendee) =>
    dispacth(editAttendeeAndRsvp(eventId, rsvp, attendee)),
  deleteRsvp: values => dispacth(deleteRsvp(values)),
  sendAppInvites: values => dispacth(sendAppInvites(values)),
  sendEmailInvite: values => dispacth(sendEmailInvite(values)),
  downloadAttendeeList: values => dispacth(downloadAttendeeList(values)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(UserManagementTab))
